//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { store } from '@/apis/member'

import { oss_files } from '@/apis/config'


export default {
    components: {
    },
    data() {
        //表單校驗
        const rules = {
            url: [{ required: true, message: '請上傳文件！' }],

        };
        const formData = {
            url: ""
        };
        return {
            id: 0,
            fileLoading: false,
            businessHours: '',
            //是否為管理員
            isAdmin: false,
            spinning: false,
            formData,
            rules,
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
            fileList: [],
            previewImage: undefined,
            previewVisible: false
        }
    },
    async mounted() {
        this.isAdmin = false;
        this.id = this.$route.params.id;
        if (this.id > 0) {
            await this.onPageLoad();
        }
    },
    methods: {
        async onPageLoad() {
            try {
                const res = await fetch(this.id);
                if (res.code == 0) {
                    // this.formData = res.data;
                    // this.formData.status = this.formData.status.toString();
                    // this.onLoadFile();
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        onLoadFile() {
            function getFileName(path) {
                const regex = /([^\/\\]+)$/;
                const match = regex.exec(path);
                if (match) {
                    return match[1];
                } else {
                    return null;
                }
            }
            const url = this.formData.url;
            if (url) {
                this.fileList = [{
                    uid: '-1',
                    name: getFileName(url),
                    status: 'done',
                    url: url,
                    thumbUrl: url,
                }]
            }
        },

        async onFileRemove(file) { 
            console.log(`output->file`, file)
        },
        //圖片上傳
        //圖片上傳
        async handleFileChange({ file, fileList }) {
            // 過濾掉非圖片文件
            if (fileList.length > 0) {
                // 過濾掉非圖片文件
                const validFiles = fileList;

                try {
                    this.fileLoading = true;
                    const formData = new FormData();
                    formData.append('file', validFiles[0].originFileObj);
                    const res = await oss_files(formData);
                    if (res.code == 200) {
                        this.formData.url = res.data.path;
                        this.fileList = validFiles;
                        this.$refs.businessHoursItem.clearValidate();
                    } else {
                        this.$message.error(res.msg);
                    }
                    console.log(`output->this.formData`, this.formData)
                } catch (error) {
                    this.$message.error(error.message);
                } finally {
                    this.fileLoading = false;
                }
            } else {
                this.fileList = fileList;
                this.formData.url = "";
            }
        },
        async handleFilePreview(file) {
            function getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = error => reject(error);
                });
            }
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj);
            }
            this.previewImage = file.url || file.preview;
            this.previewVisible = true;
        },
        handlePreviewCancel() {
            this.previewVisible = false;
        },

        handleOnFormValidate(e, v) {
            e.preventDefault();
            console.log('onFormValidate', v);
            this.$refs.form.validate(valid => {
                console.log(valid);
                if (valid) {
                    this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        async onSubmit(e) {
            let formFunction;
            const form = { ...this.formData };
            if (this.id > 0) {
                form.id = this.id;
                formFunction = update;
            } else {
                formFunction = store;
            }
            try {
                this.spinning = true;
                const res = await formFunction(form);
                if (res.code == 200) {
                    this.$message.success('提交完成');
                    this.$router.push('/member');
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
